import { DialogApp } from '../third-party/interface/dialog-app';
import { thirdPartyAppEvents, thirdPartyMediatorService, thirdPartySupportService } from '../third-party/service';
import { getSourceUrl } from '../util';

export const DIALOG_IFRAME_SELECTOR = '#dialog-iframe';
export const DIALOG_WRAPPER_SELECTOR = '#dialog-app-wrapper';
export const DIALOG_SPINNER_SELECTOR = '#dialog-app-spinner-wrapper';
export const DIALOG_BLOCKER_HIDDEN_CLASS = 'dialog-app__blocker--hidden';
export const DIALOG_SPINNER_HIDDEN_CLASS = 'dialog-app__spinner-wrapper--hidden';
export const DIALOG_BORDER_CLASS = 'dialog__iframe--border';

export class NavAppDialog extends HTMLElement {

  private dialogIframe: HTMLIFrameElement;
  private dialogIframeTemplate: HTMLIFrameElement;
  private dialogWrapper: HTMLElement;
  private dialogSpinner: HTMLElement;
  private appData: DialogApp;

  connectedCallback(): void {
    this.dialogIframe = this.querySelector(DIALOG_IFRAME_SELECTOR);
    this.dialogIframeTemplate = this.dialogIframe.cloneNode() as HTMLIFrameElement;
    this.dialogWrapper = this.querySelector(DIALOG_WRAPPER_SELECTOR);
    this.addEventListener('click', () => {
      this.close();
    });
    this.dialogSpinner = document.querySelector(DIALOG_SPINNER_SELECTOR);

    thirdPartySupportService.on(thirdPartyAppEvents.UPDATE_DIALOG, (appData) => {
      this.onModalChange(appData);
    });
  }

  private onModalChange(appData: DialogApp) {
    this.appData = appData;

    if (!appData) {
      this.resetDialog();
      return;
    }

    this.dialogWrapper.style.width = NavAppDialog.getWidth(appData);
    this.dialogWrapper.style.height = NavAppDialog.getHeight(appData);

    if (typeof appData.dialogProperties.border === 'boolean' && appData.ready) {
      this.border = appData.dialogProperties.border;
    }

    this.dialogIframe.id = `thirdPartyFrame_${appData.name}`;

    if (this.dialogIframe.src !== getSourceUrl(appData.src)) {
      this.dialogIframe.src = appData.src;
    }

    if (this.dialogIframe.name !== appData.name) {
      this.dialogIframe.name = appData.name;
    }

    if (appData.startInBackground && !appData.ready) {
      this.classList.add(DIALOG_BLOCKER_HIDDEN_CLASS);
    } else {
      this.classList.remove(DIALOG_BLOCKER_HIDDEN_CLASS);
    }

    if (appData.waitForApplicationReady && !appData.ready) {
      this.dialogSpinner.classList.remove(DIALOG_SPINNER_HIDDEN_CLASS);
    } else {
      this.dialogSpinner.classList.add(DIALOG_SPINNER_HIDDEN_CLASS);
    }
  }

  private resetDialog() {
    this.dialogWrapper.style.width = '100%';
    this.dialogWrapper.style.height = '100%';

    this.dialogIframe.remove();
    this.dialogIframe = this.dialogIframeTemplate.cloneNode() as HTMLIFrameElement;
    this.dialogWrapper.appendChild(this.dialogIframe);

    this.border = false;
    this.classList.add(DIALOG_BLOCKER_HIDDEN_CLASS);
    this.dialogSpinner.classList.add(DIALOG_SPINNER_HIDDEN_CLASS);
  }

  private set border(value: boolean) {
    if (value) {
      this.dialogIframe.classList.add(DIALOG_BORDER_CLASS);
    } else {
      this.dialogIframe.classList.remove(DIALOG_BORDER_CLASS);
    }
  }

  close(): void {
    if (this.appData) {
      thirdPartyMediatorService.closeDialog(this.appData.name);
    }
  }

  static getWidth(appData: DialogApp): string {
    return appData.dialogProperties.widthUnit ?
      appData.dialogProperties.width + appData.dialogProperties.widthUnit :
      `${appData.dialogProperties.width}px`;
  }

  static getHeight(appData: DialogApp): string {
    return appData.dialogProperties.heightUnit ?
      appData.dialogProperties.height + appData.dialogProperties.heightUnit :
      `${appData.dialogProperties.height}px`;
  }

}

window.customElements.define('nav-app-dialog', NavAppDialog);
